<template>
    <div>
        <app-data-table
            v-if="!!mails"
            :fields="fields"
            :items="theData"
            :current-page="mails.current_page"
            :last-page="mails.last_page"
            :from="mails.from"
            :to="mails.to"
            :total="mails.total"
            :per-page="mails.per_page"
            :on-change-page="onChangePage"
        >
            <template slot="created_at" slot-scope="{ item }">
                {{ item.created_at | datetime }}
            </template>
            <template slot="delivery.created_at" slot-scope="{ item }">
                {{ !!item.delivery ? item.delivery.created_at : '' | datetime }}
            </template>
            <template slot="delivered" slot-scope="{ item }">
                {{ item.delivered | yesno }}
            </template>
            <template slot="actions" slot-scope="{ item, toggleDetails }">
                <b-btn
                    size="sm"
                    variant="primary"
                    :disabled="
                        !item.photos.length &&
                            (!!item.delivery
                                ? !item.delivery.signature_url
                                : true)
                    "
                    @click="toggleDetails"
                    ><i class="fa fa-eye"></i
                ></b-btn>
            </template>
            <template slot="row-details" slot-scope="{ item }">
                <b-tabs>
                    <b-tab title="Fotos">
                        <b-row>
                            <b-col
                                cols="12"
                                md="4"
                                v-for="(photo, i) in item.photos"
                                :key="photo.id"
                            >
                                <b-img :src="photo.photo_url"></b-img>
                            </b-col>
                        </b-row>
                    </b-tab>
                    <b-tab
                        title="Firma de entrega"
                        v-if="!!item.delivery && !!item.delivery.signature_url"
                    >
                        <b-img :src="item.delivery.signature_url"></b-img>
                    </b-tab>
                </b-tabs>
            </template>
        </app-data-table>
    </div>
</template>
<script>
export default {
    props: {
        theClient: {
            type: Object,
            required: true,
        },
        venue: {
            type: Object,
            required: true,
        },
    },
    data: () => ({
        mails: null,
        page: 1,
        sortBy: 'created_at',
        sortDir: 'desc',
        fields,
        filters: null,
    }),
    computed: {
        theData() {
            if (!this.mails) return []
            return this.mails.data.map(item => ({ ...item, rowDetails: true }))
        },
    },
    methods: {
        onChangePage(page) {
            this.page = page
            this.loadMails(this.filters)
        },
        async loadMails(filters = null) {
            this.filters = filters
            const params = {
                client: this.theClient.id,
                venue: this.venue.id,
                page: this.page,
                ...this.filters,
            }
            const { data } = await repo.get('mail/paged', params)
            this.mails = data
        },
        refresh(filters = null) {
            this.page = 1
            this.loadMails(filters)
        },
    },
    mounted() {
        this.loadMails()
    },
}

const fields = [
    {
        key: 'mail_type.name',
        label: 'Tipo',
    },
    {
        key: 'destination.name',
        label: 'Destino',
    },
    {
        key: 'owner.name',
        label: 'Dueño',
    },
    {
        key: 'notes',
        label: 'Notas',
    },
    {
        key: 'created_at',
        label: 'Recibido el',
    },
    {
        key: 'user.name',
        label: 'Recibido por',
    },
    {
        key: 'delivered',
        label: 'Entregado',
    },
    {
        key: 'delivery.created_at',
        label: 'Entregado el',
    },
    {
        key: 'delivery.delivered_to',
        label: 'Entregado a',
    },
    {
        key: 'actions',
        label: 'Acciones',
    },
]
</script>
